// The Details tab (TX-US-0034): everything Operations may enter beyond the basic details, each
// field with its label, and then the engagement (TX-US-0037) - the seven answers about what
// Auremin proposes to do with the counterparty. One left empty shows a dash - the tab says what
// is known and what is not, and a counterparty from before the engagement has none of the seven.

import { Fragment } from 'react';

import { DETAIL_FIELDS } from '../CounterpartyFields.jsx';
import { ENGAGEMENT_FIELDS } from '../engagement.js';

// Where it is - country, city and region - sits in the basic details and is not repeated.
const IN_BASIC_DETAILS = ['country', 'city', 'region'];
export const TAB_FIELDS = DETAIL_FIELDS.filter((field) => !IN_BASIC_DETAILS.includes(field.name));

// A website opens in a tab of its own (TX-US-0042); everything else is text.
function detail(name, value) {
  if (value == null) return '—';
  if (name === 'website') {
    return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>;
  }
  return value;
}

export default function DetailsTab({ record }) {
  return (
    <>
      <dl className="deal-fields">
        {TAB_FIELDS.map((field) => (
          <Fragment key={field.name}>
            <dt>{field.label}</dt>
            <dd>{detail(field.name, record[field.name])}</dd>
          </Fragment>
        ))}
      </dl>

      <h3 id="engagement-heading">Engagement</h3>
      <dl className="deal-fields engagement-answers" aria-labelledby="engagement-heading">
        {ENGAGEMENT_FIELDS.map((field) => (
          <Fragment key={field.name}>
            <dt>{field.label}</dt>
            <dd>{record.engagement?.[field.name] ?? '—'}</dd>
          </Fragment>
        ))}
      </dl>
    </>
  );
}
